// ESM-Huelle fuer lib/scripts/CLS_CEmail.js (ESM-Welle 4d).
// Originalquelltext unveraendert uebernommen; nur der Export ist neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.


function CEMail(message, subject, receiver) {
	if (message) {
		return this.send(message, subject, receiver);
	} else {
		return this.check();
	}
}

CEMail.prototype.check = function (create, absolute) {

	var server = POS.EnvProperties.EMAILSERVER; //	'server.kmu-box.net';
	var port = POS.EnvProperties.EMAILPORT; //995;
	if (POS.sessions.currentSession == 0) {
		return 0;
	}
	var userid = POS.sessions.openSessions[POS.sessions.currentSession].userProps["Login"]; //'1070';
	var user = userid + '@' + POS.EnvProperties.EMAILDOMAIN;
	var pin = POS.sessions.openSessions[POS.sessions.currentSession].userProps["PIN"];
	var defret = $.Deferred();
	var me = this;
	var MailParser = require("mailparser").MailParser;
	var mailparser = new MailParser();
	var POP3Client = require("poplib");

	this.client = new POP3Client(port, server, {
			tlserrs : false,
			enabletls : true,
			debug : false
		});

	this.client.on("error", function (err) {

		if (err.errno === 111) {
			log.add(2, "Error", "Unable to connect to E-mail server " + server, err);
			console.log("Unable to connect to server");
		} else {
			log.add(2, "Error", "Server error occurred E-mail server " + server, err);
			console.log("Server error occurred");
		}
		defret.resolve(false);
		console.log(err);

	});

	this.client.on("connect", function () {

		console.log("CONNECT success");
		me.client.login(user, pin);

	});

	this.client.on("invalid-state", function (cmd) {
		log.add(2, "Error", "Invalid state. You tried calling " + cmd, err);
		console.log("Invalid state. You tried calling " + cmd);
	});

	this.client.on("locked", function (cmd) {
		console.log("Current command has not finished yet. You tried calling " + cmd);
	});

	this.client.on("login", function (status, rawdata) {

		if (status) {

			console.log("LOGIN/PASS success");
			me.client.list();

		} else {
			log.add(2, "Error", "LOGIN/PASS failed " + user, rawdata.replace("/\n\r/g",""));
			console.log("LOGIN/PASS failed");
			defret.resolve(false);
			me.client.quit();

		}
	});

	// Data is a 1-based index of messages, if there are any messages
	this.client.on("list", function (status, msgcount, msgnumber, data, rawdata) {

		if (status === false) {
			log.add(2, "Error", "list failed " + user, rawdata);
			console.log("LIST failed");
			me.client.quit();

		} else {

			console.log("LIST success with " + msgcount + " element(s)");

			if (msgcount > 0)
				me.client.retr(1);
			else
				defret.resolve(false);
			me.client.quit();

		}
	});

	this.client.on("retr", function (status, msgnumber, data, rawdata) {

		if (status === true) {

			console.log("RETR success for msgnumber " + msgnumber);

			mailparser.write(data);
			mailparser.end();
			me.client.dele(msgnumber);
			me.client.quit();

		} else {
			log.add(2, "Error", "RETR failed " + user, msgnumber);
			console.log("RETR failed for msgnumber " + msgnumber);
			defret.resolve(false);
			me.client.quit();

		}
	});

	this.client.on("dele", function (status, msgnumber, data, rawdata) {

		if (status === true) {

			console.log("DELE success for msgnumber " + msgnumber);
			me.client.quit();

		} else {
			log.add(2, "Error", "DELE failed " + user, msgnumber);
			console.log("DELE failed for msgnumber " + msgnumber);
			me.client.quit();

		}
	});

	this.client.on("quit", function (status, rawdata) {

		if (status === true)
			console.log("QUIT success");
		else
			console.log("QUIT failed");

	});

	mailparser.on("end", function (mail_object) {
		console.log("From:", mail_object.from); //[{address:'sender@example.com',name:'Sender Name'}]
		console.log("Subject:", mail_object.subject); // Hello world!
		console.log("Text body:", mail_object.text);
		var d = new Date();

		var sql = "SELECT max(EMAIL_ID) as ID from EMAILS";
		$.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
			var id = rows[0].ID;
			var text = escape(mail_object.text);
			var subj = escape(mail_object.subject);
			var from = escape(mail_object.from[0].address);
			if (isNaN(id))
				id = 0;
			id = id + 1;
			sql = "INSERT INTO EMAILS (EMAIL_ID, U_ID, Sender, Date, Subject, Body, Read, Deleted) " +
				"VALUES (" + id + "," + userid + ",'" + from + "','" + (d / 1000).toFixed(0) +
				"','" + subj + "','" + text + "',0,0)";
			$.when(POS.SQLiteCon.execute(sql)).done(function () {
				defret.resolve(true);
			});
		},function (reason) {
			var text = "M&oumlglicherweise keine Verbindung zur Hauptkasse! Zeitaufzeichnung,Emails und Lagerstand funktioniert eingeschr&aumlnkt. Zum Weiterarbeiten OK dr&uumlcken!!";
			POS.message.show(text, "warning", "OK");
			defret.resolve(false);

		});

	});
	return defret.promise();
}

CEMail.prototype.send = function (message, subject, receiver) {

	var SmtpClient = require("emailjs-smtp-client");

	var server = POS.EnvProperties.EMAILSERVER; //	'server.kmu-box.net';
	var port = POS.EnvProperties.SMTPPORT; //25;
	var userid = POS.sessions.openSessions[POS.sessions.currentSession].userProps["Login"]; //'1070';
	var user = userid + '@' + POS.EnvProperties.EMAILDOMAIN;
	var pin = POS.sessions.openSessions[POS.sessions.currentSession].userProps["PIN"];

	var options = {
		ignoreTLS : true,
		useSecureTransport : false,
		auth : {
			user : user,
			pass : pin
		}
	};
	var smtpclient = new SmtpClient(server, port, options);

	var alreadySending = false;

	smtpclient.onidle = function () {
		if (alreadySending) {
		return;
		}
		alreadySending = true;
		smtpclient.useEnvelope({
			from : user,
			to : [receiver]
		});
	}

	smtpclient.onready = function () {

		smtpclient.send("Subject: " + subject + "\r\n");
		smtpclient.send("\r\n");
		smtpclient.send(message);
		smtpclient.end();

	}

	smtpclient.ondone = function (success) {
		if (success) {
			log.add(2, "Error", "The message was transmitted successfully with " + message, success);
			console.log("The message was transmitted successfully with " + message);
		} else {
			log.add(2, "Error", "The message was NOT transmitted successfully with " + message, success);
			console.log("The message was transmitted successfully with " + message);
		}
		//alreadySending = false;
		smtpclient.close();

	}

	smtpclient.connect();
}

export { CEMail };
